var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('top-comp'),_c('second-comp'),_c('third-comp'),_c('map-comp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }